import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { isUndefined } from 'util';
import { Param } from '../../../../models/loyalty-param.model';
import { ParamOchannel } from '../../../../models/promotion-param-ochannel.model';
import { KoncentroValidators } from '../../../../modules/UIKit/validators/koncentro-validators';
import { DivisionService } from '../../../../services/division/division.service';
import { LoyaltyParamsService } from '../../../../services/loyalty/params.service';
import { PromotionOchannelService } from '../../../../services/promotion/promotion-ochannel.service';
import { PromotionParamOchannelService } from '../../../../services/promotion/promotion-param-ochannel.service';

@Component({
  selector: 'app-add-param-loyalty',
  templateUrl: './form-param-loyalty.component.html',
  styleUrls: ['./form-param-loyalty.component.css']
})
export class FormParamLoyaltyComponent implements OnInit {

  fields: any;
  fieldsChannels: any;
  public invalidSubmit: boolean;
  public validators = {
    integerNotNegative: KoncentroValidators.integerNotNegative
  };

  form: FormGroup;
  @Input() paramId: string;
  @Input() editMode: boolean;
  listFunctionCode: Array<{label: string, value: string}>;
  disabledFunctionalCode: boolean;
  filterParam: Array<string>;
  paramGroups: Array<{ label: string, value: string}>;
  //listParamOchannel: Array<{ label: string, value: number}>;
  listDivision: {label: string, value: number}[];

  ochannelsForm: Array<FormGroup>;


  constructor(    
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private paramService: LoyaltyParamsService,
    private oChannelParamService: PromotionParamOchannelService,
    private oChannelService: PromotionOchannelService,
    private divisionService: DivisionService
  ) { }

  get ochannels(): FormArray {
    return this.form.get('ochannels') as FormArray;
  }

  ngOnInit() {
    this.filterParam = [];
    this.disabledFunctionalCode = true;
    this.listFunctionCode = [];
    this.ochannelsForm = [];

    this.listDivision =  sessionStorage.getItem('paramDivisions') ? JSON.parse(sessionStorage.getItem('paramDivisions')) : [{value: null, label: ''}];
    //this.listParamOchannel =  sessionStorage.getItem('paramChannels') ? JSON.parse(sessionStorage.getItem('paramChannels')) : [{value: null, label: ''}];
    this.paramGroups = sessionStorage.getItem('paramParams') ? JSON.parse(sessionStorage.getItem('paramParams')) : [{value: null, label: ''}];

    this.listFunctionCode.push({value: null, label: ''});

    this.paramId = this.activatedRoute.snapshot.params['paramId'];
    this.editMode = (typeof this.paramId !== 'undefined');

    let param: Observable<Param>;
    let promotionParamChannel: Observable<any>;

    if (!this.editMode) {
      param = Observable.of(new Param());
      promotionParamChannel = Observable.of(new ParamOchannel());
    } else {
      param = this.paramService.get(this.paramId);
      promotionParamChannel = this.oChannelParamService.list(this.paramId);
    }

    this.paramService.getFields().subscribe(res => {
      this.fields = res;
    });

    this.paramService.getFieldsChannels().subscribe(res => {
      this.fieldsChannels = res;
    });

    if (!sessionStorage.getItem('paramDivisions')) {
      this.divisionService.getAll().subscribe(
        res => {
          for (const division of res) {
            this.listDivision.push({value: division.id, label: division.description});
          }
        },
        error => console.error(error),
        () => sessionStorage.setItem('paramDivisions', JSON.stringify(this.listDivision))
      );
    }

    /*if (!sessionStorage.getItem('paramChannels')) {
      this.oChannelService.list().subscribe(
        res => {
          for ( const oChannel of res.data) {
            this.listParamOchannel.push({value: Number(oChannel.id), label: oChannel.description});
          }
        },
        error => console.error(error),
        () => sessionStorage.setItem('paramChannels', JSON.stringify(this.listParamOchannel))
      );
    }

    if (!sessionStorage.getItem('paramParams')) {
      this.paramService.getDistinctParam().subscribe(
        res => {
          for (const paramSingle of res.data ) {
            this.paramGroups.push(paramSingle.param_group);
          }
        },
        error => console.error(error),
        () => sessionStorage.setItem('paramParams', JSON.stringify(this.paramGroups))
      );
    }
*/
    if (!sessionStorage.getItem('paramParams')) {
      this.paramService.getDistinctParam().subscribe(
        res => {          
          for (const paramSingle of res.data ) {
            
            this.paramGroups.push({value: paramSingle.param_group, label: paramSingle.param_group});
          }
        },
        error => console.error(error),
        () => sessionStorage.setItem('paramParams', JSON.stringify(this.paramGroups))
      );
    }

    Observable.zip(param, promotionParamChannel)
      .subscribe(([res, resPromotionParamChannel]) => {
        
       // if ( !isUndefined(resPromotionParamChannel.data) ) {
        if (resPromotionParamChannel) {
          for (const oChannelParam of resPromotionParamChannel) {
            this.ochannelsForm.push(this.fb.group(this.getParamOChannel(oChannelParam)));
          }
        }

        this.paramService.getFunctionalCode(res.param_group).subscribe((fc) => {
          if (fc.data.length > 0) {
            for (const functionalCode of fc.data) {
              this.listFunctionCode.push({
                value: functionalCode.map.functional_code,
                label: functionalCode.map.functional_code
              });
            }
          }
        });

        this.form = this.fb.group({
          param_group: { value: res.param_group || null, disabled: this.listFunctionCode.length > 1},
          description: res.description || null ,
          param_order: Number.isInteger(res.param_order) ? res.param_order : null ,
          param_functional_code: res.param_functional_code || null,
          division_id: res.division_id || null,
          param_code: res.param_code || null,
          param_key: res.param_key || null,
          ochannels: this.fb.array(this.ochannelsForm)
        });

      });

  }

  save() {
    if (!this.form.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    const param = new Param();
    param.description = this.form.get('description').value;
    param.param_group = this.form.get('param_group').value;
    param.param_order = +this.form.get('param_order').value;
    param.param_functional_code = this.form.get('param_functional_code').value;
    param.division_id = +this.form.get('division_id').value;
    param.param_code = this.form.get('param_code').value;
    param.param_key = this.form.get('param_key').value;
    
    if (!this.editMode) {
      this.paramService.create(param).subscribe(res => {
        this.paramId = res.id;

        //NON SI PUO' USARE GET PERCHE' NON E' DI TIPO FORMCONTROL MA FORMARRAY
        //this.saveOchannel(this.form.get('ochannels').value);
        this.saveOchannel(this.form.controls.ochannels.value);
      });
    }else {
      param.id = this.paramId;
      this.paramService.update(param).subscribe(res => {
        //NON SI PUO' USARE GET PERCHE' NON E' DI TIPO FORMCONTROL MA FORMARRAY
        //this.saveOchannel(this.form.get('ochannels').value);
        this.saveOchannel(this.form.controls.ochannels.value);
      });
    }
  }

  getFunctionalCode(value) {
    this.listFunctionCode = [{value: null, label: ''}];
    if (value !== null) {
      this.paramService.getFunctionalCode(value).subscribe((res) => {
        if (res.data.length > 0) {
          for (const functionalCode of res.data) {
            this.listFunctionCode.push({
              value: functionalCode.map.functional_code,
              label: functionalCode.map.functional_code
            });
          }
          this.disabledFunctionalCode = false;
        } else { this.disabledFunctionalCode = true; }
      });
    } else { this.disabledFunctionalCode = true; }
  }

  filterParamSingle(event) {    
    this.filterParam = [];
    // this.getFunctionalCode(event.query.toLowerCase());
    for (let param of this.paramGroups) {
      if (param && param.value && param.value.toLowerCase().indexOf(event.query.toLowerCase()) === 0) {
        this.filterParam.push(param.value);
      }
    }
  }

  selectParamSingle(event) {
    console.log(event);
    this.getFunctionalCode(event);
  }
/*
  paramKeyChange(key) {
    if (key.value) {
      this.paramService.getParamByKey(this.form.get('param_key').value).subscribe(param => {
        console.log('PARAM FOR KEY ' + key.value, param.data);

        if (Object.keys(param.data).length !== 0) {
          this.form.get('param_key').setErrors({ 'unique': false });
          this.form.get('param_key').markAsDirty({ onlySelf: true });
        } else {
          this.form.get('param_key').setErrors(null);
        }
      });
    } else {
      this.form.get('param_key').reset();
    }
  }
*/
  getParamOChannel(oChannel: ParamOchannel) {
    
    return {
      id: [oChannel.id || null],
      param_id: [oChannel.param_id || null],
      //ochannel_id: [oChannel.ochannel_id || null],
      ochannel_type_pid: [oChannel.ochannel_id || null],
      //conversion_code: [oChannel.conversion_code || ''],
      code: [oChannel.conversion_code || ''],
      description: [oChannel.description || '']
    };
  }

  addOchannel() {
    this.ochannels.push(this.fb.group(
      this.getParamOChannel(new ParamOchannel())
    ));
  }

  deleteOchannel(i: number, paramOChannel: FormGroup) {    
    if (!paramOChannel.get('id').value) {
      this.ochannels.removeAt(i);
      return;
    }
    this.oChannelParamService.remove(this.paramId, paramOChannel.get('ochannel_type_pid').value).subscribe((res) => {
      this.ochannels.removeAt(i);
    });
  }

  saveOchannel(oChannels: Array<any>) {    


    if (oChannels.length > 0) {
      const requests = [];
      for (const oChannel of oChannels) {
        let obj: ParamOchannel = new ParamOchannel();
        obj.id = oChannel.id;
        obj.description = oChannel.description;
        obj.ochannel_id = oChannel.ochannel_type_pid;
        obj.conversion_code = oChannel.code;
        obj.param_id = this.paramId;        
        if ( !obj.id ) {
          requests.push(this.oChannelParamService.create(obj));
        } else {
          requests.push(this.oChannelParamService.update(obj));
        }
      }
      Observable.zip(...requests).subscribe((resCreateDetails) => {
        this.router.navigate(['/loyalty/params/']);
      });
    }else {
      this.router.navigate(['/loyalty/params/']);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-params/form-param-loyalty/form-param-loyalty.component.ts